// eslint-disable-next-line
export const SET_USER_PROFILE = 'userProfile/set-user-profile';
